<template>
    <div class="order-box">
       <div class="statistic-box">

       </div>
       <div class="table-box">
        
       </div>
    </div>
</template>

<script>
import {getStatisticByTemple, getTable} from "@/api/order.js"
export default {
    props: {
        id: Number
    },
    data() {
        return {
            statistics:[],
            list: [],
            form:{
                page:1,
                items:5,
                total:0,
                last_page:0,
                temple_id:0
            },
            statistic_form:{
                start_date:'',
                end_date:''
            }
        };
    },
    computed: {},
    mounted() {
        this.form.temple_id = this.id
        this.init()
    },
    methods: {
        init(){
            this.getTable()
            this.getStatistic()
        },
        getTable(){
            getTable(this.form).then(res=>{
                if(res.code === 200){
                    this.list = res.data.data
                }
            })
        },
        getStatistic(){
            getStatisticByTemple(this.id,this.statistic_form).then(res=>{
                if(res.code === 200){

                }
            })
        }
    }
};
</script>

<style lang="scss" scoped>

</style>